import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Persistent File Storage/fileTypes";
import * as React from 'react';
export default {
  Content,
  React
};